import styled from "styled-components";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function Header({
  menus,
  menuAtivo,
  setMenuAtivo,
}) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();

    navigate("/login", {
      replace: true,
    });
  }

  return (
    <HeaderContainer>

      <Brand>
        SisGec<span>Med</span>
      </Brand>

      <Navigation>
        {menus.map((menu) => (
          <MenuButton
            key={menu.id}
            $active={menuAtivo?.id === menu.id}
            onClick={() => setMenuAtivo(menu)}
          >
            {menu.nome}
          </MenuButton>
        ))}
      </Navigation>

      <UserArea>

        <UserInfo>
          <small>Usuário</small>
          <strong>{user?.name}</strong>
        </UserInfo>

        <LogoutButton
          type="button"
          onClick={handleLogout}
          title="Sair do sistema"
        >
          <FiLogOut size={19} />
        </LogoutButton>

      </UserArea>

    </HeaderContainer>
  );
}

const HeaderContainer = styled.header`
  height: 68px;

  display: flex;
  align-items: center;

  padding: 0 28px;

  background: #ffffff;

  border-bottom: 1px solid #e6e9ef;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  gap: 40px;
`;

const Brand = styled.div`
  font-size: 22px;
  font-weight: 700;

  white-space: nowrap;

  color: #263238;

  span {
    color: #2e7d6e;
  }
`;

const Navigation = styled.nav`
  display: flex;
  align-items: stretch;

  height: 100%;

  gap: 6px;

  flex: 1;
`;

const MenuButton = styled.button`
  position: relative;

  border: none;

  background: transparent;

  padding: 0 18px;

  cursor: pointer;

  font-size: 14px;
  font-weight: 500;

  color: ${({ $active }) =>
    $active ? "#2e7d6e" : "#5c6670"};

  transition:
    color 0.2s ease,
    background 0.2s ease,
    transform 0.15s ease;

  &::after {
    content: "";

    position: absolute;

    bottom: 0;
    left: 50%;

    width: ${({ $active }) =>
      $active ? "70%" : "0"};

    height: 3px;

    background: #2e7d6e;

    border-radius: 3px 3px 0 0;

    transform: translateX(-50%);

    transition: width 0.25s ease;
  }

  &:hover {
    color: #2e7d6e;

    background: rgba(46, 125, 110, 0.05);

    &::after {
      width: 70%;
    }
  }

  &:active {
    transform: scale(0.97);
  }
`;

const UserArea = styled.div`
  display: flex;
  align-items: center;

  gap: 14px;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;

  text-align: right;

  small {
    color: #89939e;

    font-size: 10px;
  }

  strong {
    color: #39434d;

    font-size: 13px;
  }
`;

const LogoutButton = styled.button`
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #e1e5ea;

  border-radius: 10px;

  background: #ffffff;

  color: #66717d;

  cursor: pointer;

  transition:
    background 0.2s ease,
    color 0.2s ease,
    border 0.2s ease,
    transform 0.15s ease;

  &:hover {
    background: #fff4f4;

    color: #c0392b;

    border-color: #f0cccc;

    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.94);
  }
`;